export default function ChartCard({ title, subtitle, children, className = '', tall }) {
  return (
    <section
      className={`rounded-2xl border border-theme-secondary bg-theme-main p-4 min-w-0 ${className}`}
    >
      <div className="mb-3 px-0.5">
        <h2 className="text-sm font-semibold">{title}</h2>
        {subtitle && <p className="text-xs opacity-50 mt-0.5">{subtitle}</p>}
      </div>
      <div className={tall ? 'h-56' : 'h-44'}>{children}</div>
    </section>
  );
}
